import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function ClassListUpsert(param: any) {

    let [ClassList, setClassList] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            ClassList = param?.editDataDawer
            setClassList(ClassList)
        }
    }

    const onSave = () => {
        /*systemFormatsList.saveStatusAccount(ClassList).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Saved', 'Success')
        })*/
    }

    return (<>

        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Class List</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-6">
                            <div className="form-format">
                                <label className="control-label">ReleaseISRC*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseISRC" value={ClassList.releaseISRC ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseISRC: e.target.value })} id="releaseISRC" maxLength={50} name="ReleaseISRC" required />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Class List*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Class List" value={ClassList.classList ?? ""} onChange={(e: any) => setClassList({ ...ClassList, classList: e.target.value })} id="classList" maxLength={75} name="classList" required />

                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" title="releaseAlt1">ReleaseAlt1</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseAlt1" value={ClassList.releaseAlt1 ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseAlt1: e.target.value })} id="releaseAlt1" maxLength={75} name="releaseAlt1" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" title="releaseAlt2">ReleaseAlt2</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseAlt2" value={ClassList.releaseAlt2 ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseAlt2: e.target.value })} id="releaseAlt2" maxLength={75} name="releaseAlt2" />
                                </div>
                            </div>
                        </div>
                        <div className="ws-6">
                            <div className="form-format">
                                <label className="control-label" title="releaseAlt3">ReleaseAlt3</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseAlt3" value={ClassList.releaseAlt3 ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseAlt3: e.target.value })} id="releaseAlt3" maxLength={75} name="releaseAlt3" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" title="releaseAlt4">ReleaseAlt4</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseAlt4" value={ClassList.releaseAlt4 ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseAlt4: e.target.value })} id="releaseAlt4" maxLength={75} name="releaseAlt4" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" title="releaseAlt5">ReleaseAlt5</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseAlt5" value={ClassList.releaseAlt5 ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseAlt5: e.target.value })} id="releaseAlt5" maxLength={75} name="releaseAlt5" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" title="releaseAlt6">ReleaseAlt6</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ReleaseAlt6" value={ClassList.releaseAlt6 ?? ""} onChange={(e: any) => setClassList({ ...ClassList, releaseAlt6: e.target.value })} id="releaseAlt6" maxLength={75} name="releaseAlt6" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}